// 멀티테넌트 로그인 집중화 — Google OAuth 는 정확한 JS origin 만 허용(와일드카드 불가)이라
// 서브도메인마다 등록이 불가능하다. 그래서 로그인은 루트(cloudbtl.com) 한 곳에서만 하고,
// 세션 쿠키는 COOKIE_DOMAIN=.cloudbtl.com 으로 *.cloudbtl.com 전체에 공유된다.
// 서브도메인 /login 은 루트로 리디렉트했다가, 로그인 후 원래 서브도메인으로 돌아온다.

export const ROOT_DOMAIN =
  (import.meta.env.VITE_ROOT_DOMAIN as string | undefined) ?? 'cloudbtl.com';
const CUSTOM_TENANT_HOSTS = new Set(
  ((import.meta.env.VITE_CUSTOM_TENANT_HOSTS as string | undefined) ?? 'document.sweetsophy.com')
    .split(',')
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean),
);

function bareHost(host: string): string {
  return host.toLowerCase().replace(/:\d+$/, '');
}

/** {sub}.{ROOT_DOMAIN} 단일 레이블 테넌트 서브도메인인가 (www·루트·localhost 제외). */
export function isTenantSubdomain(host: string): boolean {
  const h = bareHost(host);
  if (h === ROOT_DOMAIN || !h.endsWith(`.${ROOT_DOMAIN}`)) return false;
  const sub = h.slice(0, -(ROOT_DOMAIN.length + 1));
  return Boolean(sub) && sub !== 'www' && !sub.includes('.');
}

export function isCustomTenantHost(host: string): boolean {
  return CUSTOM_TENANT_HOSTS.has(bareHost(host));
}

export function isWorkspaceHost(host: string): boolean {
  return isTenantSubdomain(host) || isCustomTenantHost(host);
}

/** 로그인 후 돌아갈 URL 화이트리스트 — https + 루트/단일레이블 서브도메인만(open redirect 차단). */
export function isAllowedReturnUrl(raw: string | null | undefined): boolean {
  if (!raw) return false;
  try {
    const url = new URL(raw);
    if (url.protocol !== 'https:') return false;
    const h = bareHost(url.hostname);
    if (h === ROOT_DOMAIN) return true;
    if (CUSTOM_TENANT_HOSTS.has(h)) return true;
    if (!h.endsWith(`.${ROOT_DOMAIN}`)) return false;
    const sub = h.slice(0, -(ROOT_DOMAIN.length + 1));
    return Boolean(sub) && !sub.includes('.');
  } catch {
    return false;
  }
}

/** 루트 로그인 URL — 로그인 완료 후 returnUrl 로 돌려보낸다. */
export function buildRootLoginUrl(returnUrl: string): string {
  return `https://${ROOT_DOMAIN}/login?return=${encodeURIComponent(returnUrl)}`;
}
